import { render, staticRenderFns } from "./QualityReportActionLayout.vue?vue&type=template&id=2d98b452&scoped=true&"
import script from "./QualityReportActionLayout.vue?vue&type=script&lang=js&"
export * from "./QualityReportActionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d98b452",
  null
  
)

export default component.exports